// src/components/ProductCard/ProductCard.jsx
import React from 'react';
import styles from './ProductCard.module.css';

/**
 * 商品卡片组件 - 简化版（无轮播）
 */
export default function ProductCard({ product, onClick }) {
    // 只使用第一张图片
    const mainImage = product.images ? product.images[0] : product.image;

    return (
        <div className={styles.productCard} onClick={onClick}>
            <div className={styles.imageWrapper}>
                <img
                    src={mainImage}
                    alt={product.name}
                    className={styles.productImage}
                    loading="lazy"
                />
            </div>

            <div className={styles.productInfo}>
                <h3 className={styles.productName}>{product.name}</h3>
                <p className={styles.productPrice}>From $ {product.price}</p>
            </div>
        </div>
    );
}
